import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import buildUrlWithParams from "./buildUrlWithParams";

const PAGE_SIZE = 100;

const noteMetaDataMinimalsQueryOptions = (params: {
  skip?: number;
  limit?: number;
  partnerCognitoSub?: string;
  appointmentId?: number;
  groupSessionId?: number;
  noteDataId?: number[];
  practiceGroup?: boolean;
}) => {
  return queryOptions({
    queryKey: ["noteMetaDataMinimals", params],
    queryFn: async ({ signal }) => {
      const url = buildUrlWithParams("/api/notes/v1/notes/", params);

      const res = await fetchOrchidAPI(url, { signal });
      if (!res.ok) {
        throw new Error(
          `failed to query note data minimals: ${getErrorDetail(
            await res.text(),
          )}`,
        );
      }
      const json = await res.json();
      return json as NoteMetaDataMinimal[];
    },
  });
};

export const noteMetaDataMinimalsInfiniteQueryOptions = (params: {
  partnerCognitoSub?: string;
  appointmentId?: number;
  groupSessionId?: number;
  noteDataId?: number[];
  practiceGroup?: boolean;
  onBehalfOf?: string;
}) => {
  return infiniteQueryOptions({
    queryKey: ["noteMetaDataMinimals", params],
    queryFn: async ({ pageParam, signal }) => {
      const url = buildUrlWithParams("/api/notes/v1/notes/", {
        ...params,
        limit: PAGE_SIZE,
        skip: pageParam * PAGE_SIZE,
      });

      const res = await fetchOrchidAPI(url, { signal });
      if (!res.ok) {
        throw new Error(
          `failed to query note data minimals: ${getErrorDetail(
            await res.text(),
          )}`,
        );
      }
      const json = await res.json();
      return json as NoteMetaDataMinimal[];
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, pages) => {
      const hasMore = lastPage.length === PAGE_SIZE;
      if (!hasMore) {
        return undefined;
      }
      return pages.length;
    },
  });
};

export default noteMetaDataMinimalsQueryOptions;
